import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EScheduleSteps, updateScheduleSteps } from '../../../../features/schedule/schedule-slice';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { RootState } from '../../../../store';
import Modal from '../../Modal/ModalBasic';
import { ButtonCustom } from '../../JourneyActionManager/AwaitingScheduleReturn/ChooseReturnType/styled';
import {
  clearCalendarSelected,
  prepareToCalendarSelected,
  saveCalendarSelected,
  withTheSameDoctor
} from '../../../../features/calendar/calendar-slice';
import { dynamicCustomEventTracking } from '../../../../lib/gtm';

interface ISelectAvailableTimes {
  open: boolean;
  onFinished: () => void;
}

const RescheduleAppointment = ({ open, onFinished }: ISelectAvailableTimes) => {
  const dispatch = useDispatch();
  const {
    calendar: { calendarsAvailables, isReSchedule, schedule }
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    if (calendarsAvailables.length > 1) dispatch(prepareToCalendarSelected({ isReSchedule: isReSchedule }));
  }, []);

  return (
    <Modal
      open={open}
      onCloseHandler={() => {
        dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.idle, previousStep: EScheduleSteps.idle }));
        dispatch(clearCalendarSelected());
      }}
      title={schedule?.rescheduleAlert ? 'Tem certeza que deseja reagendar?' : 'Como você gostaria de reagendar?'}
      typeTitle="h3"
    >
      <Box mb={1} mt={1}>
        {schedule?.rescheduleAlert && (
          <Typography variant="body1" sx={{ mt: 1, mb: 4 }}>
            A Dra. {schedule?.user.name} reservou este horário especialmente para você e está te esperando. Devido a alta
            demanda, os horários de reagendamento no nosso calendário podem ser reduzidos.
          </Typography>
        )}
        <ButtonCustom
          onClick={() => {
            if (calendarsAvailables.length === 1) {
              dispatch(saveCalendarSelected({ calendar: calendarsAvailables[0] }));
            }
            dispatch(withTheSameDoctor(true));
            dynamicCustomEventTracking.send({
              dynamicEventName: 'reschedule_appointment_with_same_doctor'
            });
            onFinished();
          }}
        >
          Com a mesma médica (Dra. {schedule?.user?.name})
        </ButtonCustom>
      </Box>
      <Box mb={1} mt={1}>
        <ButtonCustom
          onClick={() => {
            if (calendarsAvailables.length === 1) {
              dispatch(saveCalendarSelected({ calendar: calendarsAvailables[0] }));
            }
            dispatch(withTheSameDoctor(false));
            dynamicCustomEventTracking.send({
              dynamicEventName: 'reschedule_appointment_with_any_doctor'
            });
            onFinished();
          }}
        >
          Por disponibilidade de horário (todas as médicas)
        </ButtonCustom>
      </Box>
    </Modal>
  );
};

export default RescheduleAppointment;
